<template>
  <div>
    <v-container class="common-page-container">
      <h1>Terms of service</h1>
      <p>
        <nuxt-link to="/fr/conditions-d-utilisation" rel="nofollow">
          Version française
        </nuxt-link>
      </p>
      <h2 class="mt-10">
        TABLE OF CONTENTS
      </h2>
      <ul>
        <li>Article 1 : Object</li>
        <li>Article 2 : Terms of service</li>
        <li>
          Article 3 : Obligations
          <ul>
            <li>3.1 User's obligations</li>
            <li>3.2 Main rules</li>
            <li>3.3 Infringement of the terms of service</li>
          </ul>
        </li>
        <li>
          Article 4 : Privacy
          <ul>
            <li>4.1 Personal data protection</li>
            <li>4.2 Right of access to information</li>
            <li>4.3 Cookies</li>
          </ul>
        </li>
        <li>
          Article 5 : Intellectual property
          <ul>
            <li>5.1 Licenses of our contents</li>
            <li>5.2 Copyright infringement</li>
            <li>5.3 Conditions resulting from the website's interactivity</li>
          </ul>
        </li>
        <li>
          Article 6 : Responsibilities
          <ul>
            <li>6.1 Hardware damages and data loss</li>
            <li>6.2 Responsibility while practicing sport activities</li>
            <li>6.3 Climbing partner search</li>
          </ul>
        </li>
        <li>
          Article 7 : Limitation of warranties
        </li>
        <li>
          Article 8 : Hyperlinks
          <ul>
            <li>8.1 Hyperlinks pointing to oblyk.org</li>
            <li>8.2 Hyperlinks pointing to third party websites</li>
          </ul>
        </li>
        <li>Article 9 : Applicable Law</li>
      </ul>

      <h3>Article 1 : Object</h3>
      <p>
        The general terms of service aim to define the conditions of availability of the <strong>Oblyk.org</strong>
        services by the user. Each access and use of <strong>Oblyk.org</strong> is subject to the respect of all the
        rules and obligations described in the general terms of service, without any restriction.
      </p>
      <p>
        Each private individual or legal entity willing to access the <strong>Oblyk.org</strong> service must have read
        all the terms of service beforehand, which can be found in the footer of each page of the website. Hence, it
        will be considered that the user has fully read the terms of service and agreed with them, only by using
        <strong>Oblyk.org</strong>.
      </p>
      <p>
        <strong>Oblyk.org</strong> reserves the right to edit or update the terms of service at any time.
      </p>

      <h3>Article 2 : Terms of service</h3>
      <p>
        According to article 6 of the law of confidence in the digital economy n°2004-575 of June 21st 2004, it is
        stated to <strong>Oblyk.org</strong> users the identity of the website's owners, and of the hosting provider.
      </p>
      <p class="mb-0">
        <strong>Oblyk.org</strong> was published by Oblyk SAS.
      </p>
      <p>
        Simplified joint stock company with capital of €1,000. Domiciled at 139 Avenue Maréchal de Saxe 69003, LYON<br>
        SIRET : 98515257800011
      </p>
      <p>
        The editing director of <strong>Oblyk.org</strong> are Lucien Chastan.
      </p>
      <p>
        Contact : <a href="mailto:ekip@oblyk.org">ekip@oblyk.org</a>
      </p>
      <p>
        <u><strong>Oblyk.org</strong> App and API hosting :</u><br>
        The <strong>Oblyk.org</strong> web application is hosted by <a href="https://onetsolutions.net/">ONETSOLUTIONS</a> - Société par action simplifiée. 1 Allée de l'Ecluse, 33370 YVRAC
      </p>
      <p>
        <u><strong>Oblyk.org</strong> Documentation hosting :</u><br>
        <strong>Oblyk.org</strong> documentation is generated and hosted by <a href="https://github.com/">Github</a>
      </p>
      <p>
        The processing of data on <strong>Oblyk.org</strong> is carried out in full conformity with privacy and legality
        : in accordance with the legal provisions of law n°78-17 of January 6th 1978 related to data processing, files
        and freedom, this website has been subject to a declaration to the National Commission for Data Protection and
        Liberties (CNIL) : n°1890811v0.
      </p>

      <h3>Article 3 : Obligations</h3>

      <h4>3.1 User's obligations</h4>
      <p>
        By accepting <strong>Oblyk.org</strong> terms of service, the user abstains from engaging in actions of any
        kind, such as editing, posting online, broadcasting or distributing content, information and data that would be
        against the law, or that may violate public order, <strong>Oblyk.org</strong> rights, or third party rights.
      </p>

      <h4>3.2 Main rules</h4>
      <p>
        Therefore, the user commits to respecting the following rules ( non-exhaustive list ) :
      </p>
      <ul class="mb-6">
        <li>
          to comply with applicable laws, to respect the general terms of service, and the rights of third parties
        </li>
        <li>
          not to create, broadcast, transmit, communicate or store information and data of a defamatory, abusive,
          offensive, obscene, pornographic (or related to child pornography), racist, xenophobic, homophobic,
          discriminatory nature, and more generally any content contrary to public order
        </li>
        <li>
          to respect the intellectual property rights related to the contents broadcasted on <strong>oblyk.org</strong>
        </li>
        <li>
          not to divert one of <strong>Oblyk.org</strong> features from its normal use
        </li>
        <li>
          not to broadcast content, data or information that does not reflect reality
        </li>
        <li>
          not to broadcast contents, data or information likely to lessen, disorganize or prevent a normal use of
          <strong>Oblyk.org</strong>
        </li>
      </ul>

      <h4>3.3 Infringement of the terms of service</h4>
      <p>
        In case the terms of service have not been respected, <strong>Oblyk.org</strong> will be able to remove all or
        part of the contents broadcasted online by the malicious users. Each user has the right to report a content he
        considers opposite to the terms of service, by contacting <strong>Obyk.org</strong> administrators.
      </p>

      <h3>Article 4 : Privacy</h3>

      <h4>4.1 Personal data protection</h4>
      <p>
        According to the law n°78-87 of January 6th 1978, the law n°2004-80 of August 6th 2004, the article L. 226-13 of
        Penal Code, and the European Parliament and October 24th 1995 Council directive, the user's personal data
        collected during his registration is protected. It is subject to computer processing :
        <strong>Oblyk.org</strong> only uses it so that the user can access the different services and features provided
        by this website. This data may also be used by <strong>Oblyk.org</strong> for statistical purposes, to know the
        traffic on the site, or to have a better targeting of the new features developed. By no means will this data be
        transmitted to third parties (persons or business partners) : they remain the ownership of
        <strong>Oblyk.org</strong>, which ensures their confidentiality.
      </p>

      <h4>4.2 Right of access to information</h4>
      <p>
        As required by articles 39 and 40 of the law n°78-17 of January 6th 1978, the user can choose anytime to access
        his personal data held by <strong>Oblyk.org</strong>, but also ask for their modification or deletion.
      </p>

      <h4>4.3 Cookies</h4>
      <p>
        <strong>Oblyk.org</strong> uses cookies, which are markers allowing a better experience on the website ( backup
        of some settings in memory on the web browser, to fasten the website's browsing).
      </p>
      <p>
        Cookies are anonymous and can't be used to collect personal data. None of this anonymous data will be
        transmitted to business partners, or third parties : their remain in the ownership of <strong>Oblyk.org</strong>.
      </p>
      <p>
        For more information, please consult the :
        <nuxt-link to="/en/cookie-and-audience-measurement">
          Cookie & Audience measurement
        </nuxt-link>
      </p>

      <h3>Article 5 : Intellectual property</h3>

      <h4>5.1 Licenses of our contents</h4>
      <p>
        Two types of contents can be distinguished on <strong>Oblyk.org</strong> : personal content, and community
        content.
      </p>
      <p>
        The personal content includes everything that is posted by the user on his profile : the routes he ticks off in
        his sendlist, his personal data, his pictures, his private messages, and his messages on the forum. This content
        is subject to copyright, and the author is the user in question.
      </p>
      <p>
        The community content includes the users contributions to <strong>Oblyk.org</strong> : crags, sectors and routes
        they add to the website's database (and the detailed information related to it), comments (public or anonymous),
        words added to the glossary, links posted, guidebooks added to the database, pictures posted for the community.
      </p>
      <p>
        The community content's owner is ©Oblyk. This content is dual licensed :
        <a href="https://creativecommons.org/licenses/?lang=e">CC BY-NC-SA</a>
        (regarding the content) , and
        <a href="https://opendatacommons.org/licenses/odbl/">Open Database License</a>
        (regarding the database).
      </p>
      <p>
        You are free to remix, arrange, and adapt our work to non commercial ends, as long as you acknowledge our name
        and as long as your derivative work is subject to the same terms. Please acknowledge ©Oblyk, indicate the link
        of the source document on <a href="https://oblyk.org">oblyk.org</a>, and insert the two license's names (CC
        BY-NC-SA and Open Database License), as well as a hyperlink pointing to each of these licenses.
      </p>

      <h4>5.2 Copyright infringement</h4>
      <p>
        We remind the oblyk users that they must never add data coming from copyrighted sources or from related rights
        sources without an express authorization of these right holders.
      </p>
      <p>
        If you think that some content may have been added to the <strong>Oblyk.org</strong> database in breach of these
        copyrights, please contact us at <a href="mailto:ekip@oblyk.org">ekip@oblyk.org</a>.
      </p>

      <h4>5.3 Conditions resulting from the website's interactivity</h4>
      <p>
        By adding content (text, picture, or anything else) in one of the website's interactive sections, the user
        transfers expressly and gracefully the right to broadcast this content (reproduction, representation,
        adaptation) to <strong>Oblyk.org</strong>, by any means (each known support or unknown yet), for the whole world
        and for the duration of intellectual property ( current and upcoming ). The copyrights remain reserved.
      </p>
      <p>
        <strong>Oblyk.org</strong> reserves the right to publish ( or not ) the contributions it receives on the
        website, to edit or adapt them, to translate them into another language, to keep them or to delete them at any
        time.
      </p>
      <p>
        The user is the only person accountable for the content that he posts on <strong>Oblyk.org</strong>. As such, he
        guarantees <strong>Oblyk.org</strong> against any legal action that may result from its broadcast. He is
        criminally and financially accountable for the potential infringements of individual rights, privacy rights,
        human dignity rights, and copyrights that would be caused by his contribution.
      </p>
      <p>
        The user's contributions are the sole responsibility of his author and do not represent, in any case, an
        official position of <strong>Oblyk.org</strong>.
      </p>

      <h3>Article 6 : Responsibilities</h3>
      <p>
        The use of <strong>Oblyk.org</strong> is done under the sole responsibility of the users.
      </p>

      <h4>6.1 Hardware damages and data loss</h4>
      <p>
        Subject to the applicable legal provisions, <strong>Oblyk.org</strong> shall not be held responsible for any
        damage, direct or indirect ( such as loss of profits, of consumers, of data, of intangible assets :
        non-exhaustive list) resulting from the use or the impossibility of use of the website, and more generally from
        any event related to our website and/or to any third party website. Any hardware or content downloaded on
        <strong>Oblyk.org</strong> is at the user's own risk. <strong>Oblyk.org</strong> shall not be held responsible
        for potential damages or data loss suffered by the user's computer.
      </p>

      <h4>6.2 Responsibility while practicing sport activities</h4>
      <p>
        The practice of sport activities (such as climbing or other mountain related sports) must be carried out with an
        advanced knowledge of the ground and of the technical skills of the sport in question, and implies the
        acceptation of a risk level which must be adapted to each person's abilities. <strong>Oblyk.org</strong>
        encourages its users to be really careful when they interpret the data and the information referenced by the
        community. By no means does <strong>Oblyk.org</strong> guarantee the accuracy and the comprehensiveness of the
        indications provided directly on this website (such as the type of bolts or anchors, the height of a route, the
        advices given in the forum or in the comments, etc. non-exhaustive list). All this information is
        non-contractual and cannot engage the responsibility of <strong>Oblyk.org</strong> and of the authors of the
        contents in question. Moreover, these indications cannot replace the advices of a skilled professional for the
        sport activity in question. <strong>Oblyk.org</strong> accepts no responsibility related to incidents of any
        kind that may result from the use or interpretation of the information broadcasted on its website.
      </p>

      <h4>6.3 Climbing partner search</h4>
      <p>
        <strong>Oblyk.org</strong> cannot be held responsible for the behaviour or actions of persons who meet or
        communicate with each other as a result of using the partner tracing service.
      </p>
      <p class="red--text">
        The partner tracing service is forbidden to underage.
      </p>
      <p>
        For the partner search service to work, the user must fill in his or her date of birth..
        <strong>Oblyk.org</strong> cannot be held responsible if the user indicates a false date of birth in order to
        use the service despite the restrictions.
      </p>

      <h3>Article 7 : Limitation of warranties</h3>
      <p>
        <strong>Oblyk.org</strong> reserves the right, at any time, to interrupt temporarily or definitively all or part
        of this website, without previous notice and compensation. By no means shall <strong>Oblyk.org</strong> be held
        responsible for the consequences of such a decision.
      </p>

      <h3>Article 8 : Hyperlinks</h3>

      <h4>8.1 Hyperlinks pointing to oblyk.org</h4>
      <p>
        The hyperlinks pointing to any page of the website (home page or another page) are allowed and strongly
        encouraged. However, <strong>Oblyk.org</strong> exercises no control over third party websites, and therefore
        cannot assume responsibility concerning contents, products, services, information, hardwares, softwares of
        external websites providing a hyperlink pointing to <strong>Oblyk.org</strong>.
      </p>

      <h4>8.2 Hyperlinks pointing to third party websites</h4>
      <p>
        <strong>Oblyk.org</strong> may contain hyperlinks pointing to third party websites, but exercises no control
        over these websites, and therefore cannot assume responsibility concerning the contents, advertising, products
        and services available on theses websites or from these websites. <strong>Oblyk.org</strong> shall not be held
        accountable for direct or indirect damages resulting from the access of one of its users to a third party
        website, or from the use of the services provided by these websites.
      </p>

      <h3>Article 9 : Applicable Law</h3>
      <p>
        The website <strong>Oblyk.org</strong> is subject to French Law.
      </p>
    </v-container>

    <app-footer />
  </div>
</template>

<script>
import AppFooter from '@/components/layouts/AppFooter'

export default {
  components: { AppFooter },

  head () {
    return {
      title: 'Terms and conditions of use',
      meta: [
        { hid: 'robots', name: 'robots', content: 'noindex' },
        { hid: 'description', name: 'description', content: 'See the general terms of use of Oblyk, the climbing community website : our privacy policy and our legal notice' },
        { hid: 'og:title', property: 'og:title', content: 'Terms and conditions of use' },
        { hid: 'og:description', property: 'og:description', content: 'See the general terms of use of Oblyk, the climbing community website : our privacy policy and our legal notice' },
        { hid: 'og:image', property: 'og:image', content: `${process.env.VUE_APP_OBLYK_APP_URL}/images/oblyk-og-image.jpg` }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
h3 {
  margin-top: 3em;
  margin-bottom: 0.5em;
}
p {
  text-align: justify;
  hyphens: auto;
}
</style>
